import { Alert, Typography, theme } from '@capitalise/ui-design-system';
import styled from 'styled-components';

const Ul = styled.ul`
  list-style-type: disc;
`;

const Li = styled.li`
  list-style-position: inside;
  overflow-wrap: anywhere;
  word-break: break-word;
  margin-top: ${theme.sizes.xtiny};
`;

const CustomTypography = styled(Typography)`
  display: inline;
`;

const ConsentPurposeAlert = (props) => {
  return (
    <Alert type="info" wrapperProps={props}>
      <Typography size="heading-16">We only use this data for verification purposes</Typography>
      <Ul>
        <Li>
          <CustomTypography size="body-16">
            No impact to the director’s personal or company credit scores
          </CustomTypography>
        </Li>
        <Li>
          <CustomTypography size="body-16">No personal data is stored</CustomTypography>
        </Li>
        <Li>
          <CustomTypography size="body-16">We won’t contact any directors</CustomTypography>
        </Li>
      </Ul>
    </Alert>
  );
};

export default ConsentPurposeAlert;
